import React, { useCallback } from 'react';
import { useI18n } from '@locales/client';
import { useBanners } from '@/entities/minibanner/model/hooks';
import { useConfirmDataPrompt } from '@/features/data-managment/model/hooks';
import { LazyImage } from '@/shared/ui/lazy-image/lazy-image';
import { Box } from '@/shared/ui/box';
import { BodyTextRegularPrimary } from '@/shared/ui/typography';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { Link } from '@/shared/ui/link';
import { ContentRow, ContentRows, CounterBlock } from './styles';

const Banners = ({ mobileLandscape }) => {
  const t = useI18n();
  const { sortedBanners, linkBanners, categoryParam } =
    useBanners(mobileLandscape);
  const { user } = useUser();
  const { addQueryParam } = useConfirmDataPrompt();

  const handleClick = useCallback(
    (key, disabled, e) => {
      if (key === 'promocodes' && !user?.id) {
        e.preventDefault();
        addQueryParam('registration');
        return;
      }

      if (disabled) {
        e.preventDefault();
      }
    },
    [user, addQueryParam]
  );

  return (
    <ContentRows data-section="banners">
      {sortedBanners.map((banner) => (
        <Link
          href={banner.disabled ? '#' : linkBanners(banner.param)}
          key={banner.id}
          passHref
          onClick={(e) => handleClick(banner?.param, banner.disabled, e)}
        >
          <ContentRow
            $isActive={categoryParam === banner.param}
            $isDisabled={banner.disabled}
            as="div"
          >
            <Box $width={[58, 32]} $height={[58, 32]} $margin="0 auto 2px">
              <LazyImage fill src={banner.image} />
              {!!banner.counter && (
                <CounterBlock>{banner.counter}</CounterBlock>
              )}
            </Box>
            <BodyTextRegularPrimary>{t(banner.tKey)}</BodyTextRegularPrimary>
          </ContentRow>
        </Link>
      ))}
    </ContentRows>
  );
};

const BannersBreakpointsSlice = withBreakpointsSlice(
  Banners,
  ({ mobileLandscape }) => ({
    mobileLandscape,
  })
);

export { BannersBreakpointsSlice as Banners };
